import { dateKey } from '../../lib/dateKey';
import { loadDailyProgress } from '../../lib/storage/indexedDb';
import type { Profile, SyncedTree } from '../../lib/types';
import { padCompleted } from '../progress/padCompleted';
import { getProfileRoutines } from './routineMutations';

// Decide where a profile entry (quick-switcher tap) should land. If exactly
// one routine is *ongoing today* — started but not finished — jump straight
// to it. Otherwise the routine selector. An ongoing routine is one with at
// least one true and at least one false in its progress array.
//
// Untouched routines do not count as ongoing, so the first-thing-in-the-
// morning case (no progress at all) keeps showing the routine selector.
export async function pickEntryRoute(tree: SyncedTree, profile: Profile): Promise<string> {
  const dp = await loadDailyProgress(profile.id, dateKey());
  const routines = getProfileRoutines(tree, profile.id);
  const ongoing = routines.filter((r) => {
    const padded = padCompleted(dp?.routines[r.id] ?? [], r.tasks.length);
    return padded.some(Boolean) && !padded.every(Boolean);
  });
  if (ongoing.length === 1) {
    const [only] = ongoing;
    if (only) return `/p/${profile.id}/list/${only.id}`;
  }
  return `/p/${profile.id}`;
}
